const routes = [
    {
        path: "/student/club/votes",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "studentclubvote_index"
        }
    },
    {
        path: '/student/club/vote/options/:id',
        component: () => import('../pages/voteOptions/Index'),
        meta: {
            isAuthenticated: true,
            permission: 'studentclubvoteoption_index'
        }
    },
    {
        path: '/student/club/votes/vote-result/:id',
        component: () => import('../pages/voteResults/Index'),
        meta: {
            isAuthenticated: true,
            permission: 'studentclubvote_voteresult'
        }
    },
];

export default routes;
